import { ChangeEvent, FC, useCallback, useMemo, useState } from 'react';

import { Search } from '@beeline/design-system-react/extracted-styles';

import { spacesActions } from 'src/store/spaces/slice';
import { useAppDispatch } from 'src/store/useAppDispatch';
import { debounce } from 'src/utils/debounce';

const delayMs = 300;

export const SearchSpace: FC = () => {
  const dispatch = useAppDispatch();

  const setSearch = useCallback(
    (input: string) => {
      dispatch(spacesActions.setSearch(input));
    },
    [dispatch],
  );

  const [value, setValue] = useState('');

  const setSearchDebounced = useMemo(
    () => debounce(setSearch, delayMs),
    [setSearch],
  );

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setValue(event.target.value);
      setSearchDebounced(event.target.value);
    },
    [setSearchDebounced],
  );

  const handleClear = useCallback(() => {
    setValue('');
    setSearch('');
  }, [setSearch]);

  return (
    <Search
      placeholder='Пространство'
      fullWidth
      value={value}
      onChange={handleChange}
      onClear={handleClear}
    />
  );
};
